/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs */

const en_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-commerce platform`)
};

const ar_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منصة تجارة إلكترونية`)
};

const bn_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ই-কমার্স প্ল্যাটফর্ম`)
};

const de_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Commerce-Plattform`)
};

const es_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataforma de comercio electrónico`)
};

const fr_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plateforme de commerce électronique`)
};

const pt_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataforma de comércio eletrônico`)
};

const zh_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电商平台`)
};

const tr_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-ticaret platformu`)
};

const ru_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформа электронной коммерции`)
};

const pl_svc_full_stack_web_apps_work_1_badge = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforma e-commerce`)
};

/**
* | output |
* | --- |
* | "E-commerce platform" |
*
* @param {Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_work_1_badge = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Work_1_BadgeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_work_1_badge(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_work_1_badge(inputs)
	return en_svc_full_stack_web_apps_work_1_badge(inputs)
});
export { svc_full_stack_web_apps_work_1_badge as "svc_full-stack-web-apps_work_1_badge" }